import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { ModalElement } from '../../../components/modal/modalElement';
import Form from 'react-bootstrap/Form';
import './btnStopwatch.style.css';
import api from "../../../services/api";

function BtnStopwatch(props) {
    const { state } = useLocation();
    const navigate = useNavigate();

    const [bookInformation, setBookInformation] = useState(state);
    const [saveReadModal, setSaveReadModal] = useState(false);
    const [startPage, setStartPage] = useState(0);
    const [stoppedPage, setStoppedPage] = useState(0);
    const [hour, setHour] = useState(0);
    const [minute, setMinute] = useState(0);
    const [second, setSecond] = useState(0);

    const redirectToHome = () => {
        navigate('/home');
    }

    const saveRead = (hours, minutes, seconds) => {
        setHour(parseInt(hours));
        setMinute(parseInt(minutes));
        setSecond(parseInt(seconds));
        setSaveReadModal(true);
    }
    
    function sumTime(time1, time2) {
        var array1 = time1.split(':');
        var time_sec1 = (parseInt(array1[0]) * 3600) + (parseInt(array1[1]) * 60) + parseInt(array1[2]);
        
        var array2 = time2.split(':');
        var time_sec2 = (parseInt(array2[0]) * 3600) + (parseInt(array2[1]) * 60) + parseInt(array2[2]);
        
        var finalTime = parseInt(time_sec1) + parseInt(time_sec2);
        
        var hours = Math.floor(finalTime / (60 * 60));
        
        var sliceMinutes = finalTime % (60 * 60);
        var minutes = Math.floor(sliceMinutes / 60);
        
        var sliceSeconds = sliceMinutes % 60;
        var seconds = Math.ceil(sliceSeconds);
        
        var count = "";
        
        if (hours < 10) { count = "0" + hours + ":"; } else { count = hours + ":"; }
        if (minutes < 10) { count += "0" + minutes + ":"; } else { count += minutes + ":"; }
        if (seconds < 10) { count += "0" + seconds; } else { count += seconds; }
        
        return count;
    }

    const calculateTime = () => {
        const newTime = `${hour}:${minute}:${second}`;
        const timeDb = bookInformation?.readingStatus?.readingTime || '00:00:00';
        return sumTime(newTime, timeDb);
    }

    const saveAndRedirectToHome = async () => {
        const finalTimeToSave = calculateTime();

        try {
            await api.put(`/readings/${bookInformation.book.id}`, {
                initialPage: startPage,
                currentPage: stoppedPage,
                readingTime: finalTimeToSave.toString()
             }, {
                headers: {
                    'x-session-token': JSON.parse(localStorage.getItem('token')),
                }
            });
            redirectToHome();
        } catch(error) {
            console.error(error);
        }
    }

    return (
        <div className='btns-group-timer'>
            {props.status === 0 &&
                <div className='btns-group-timer-children'>
                    <div className='container-btns-start-pause'>
                        <Button size="lg" className='btn-zerar text-button' onClick={props.reset} variant="secondary">Zerar</Button>
                        <Button size="lg" className='btn-iniciar text-button' onClick={props.start} variant="secondary">Iniciar</Button>
                    </div>
                   <div className='container-btn-close'>
                        <Button size="lg" className='btn-terminei text-button' onClick={() => redirectToHome()} variant="secondary">Fechar</Button>
                    </div>
                </div>
            }
            {props.status === 1 &&
                <div className='btns-group-timer-children'>
                    <div className='container-btns-start-pause'>
                        <Button size="lg" className='btn-zerar text-button' onClick={props.reset} variant="secondary">Zerar</Button>
                        <Button size="lg" className='btn-iniciar btn-pause text-button' onClick={props.stop} variant="secondary">Pause</Button>
                    </div>
                    <div className='container-btn-close'>
                        <Button size="lg" className='btn-terminei text-button' onClick={() => saveRead(props.hour, props.minute, props.second)} variant="secondary">Terminei</Button>
                   </div>
                </div>
            }
            {props.status === 2 &&
                <div className='btns-group-timer-children'>
                    <div className='container-btns-start-pause'>
                        <Button size="lg" className='btn-zerar text-button' onClick={props.reset} variant="secondary">Zerar</Button>
                        <Button size="lg" className='btn-iniciar text-button' onClick={props.start} variant="secondary">Iniciar</Button>
                    </div>
                    <div className='container-btn-close'>
                        <Button size="lg" className='btn-terminei text-button' onClick={() => saveRead(props.hour, props.minute, props.second)} variant="secondary">Terminei</Button>
                    </div>
                </div>
            }
            <ModalElement
                    show={saveReadModal}
                    onHide={() => setSaveReadModal(false)}
                    size='sm'
            >
                <h2 className='modal-save-read-title'>Marcando seu texto!</h2>
                <p className='modal-save-read-text'>Total de páginas do livro: {bookInformation?.book?.pages || 0}</p>
                <p className='modal-save-read-text'>Última página anotada: {bookInformation?.readingStatus?.currentPage || 0}</p>
                <Form>
                    <Form.Group className="mb-3 save-read-input">
                        <Form.Label className='save-read-label'>Página em que iniciou: </Form.Label>
                        <Form.Control className='save-read-input-box' type="number" size="sm" min={0} onChange={(e) => setStartPage(e.target.value)}/>
                    </Form.Group>
                    <Form.Group className="mb-3 save-read-input">
                        <Form.Label className='save-read-label'>Página em que parou: </Form.Label>
                        <Form.Control className='save-read-input-box-2' type="number" size="sm" min={0} onChange={(e) => setStoppedPage(e.target.value)}/>
                    </Form.Group>
                </Form>
                <Button className="btn-save-read" onClick={() => saveAndRedirectToHome()}>ANOTA AÍ</Button>
            </ModalElement> 
        </div>
    );
}

export default BtnStopwatch;